import React from 'react';

/** A simple bootstrap progress bar. See https://getbootstrap.com/docs/3.3/components/#progress*/
export function ProgressBar({progress, text}) {
  const percentage = progress*100;
  return <div className="progress">
    <div className="progress-bar" role="progressbar" aria-valuenow={percentage} aria-valuemin="0" aria-valuemax="100" style={{width: percentage+"%", "transitionDuration": "15ms"}}>
      {text}
    </div>
  </div>;
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/ProgressBar.jsx